import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from "firebase/analytics";
import type { Analytics } from "firebase/analytics";
import {testFirebaseConfig, prodFirebaseConfig} from './firebaseConfig'
import config from '../config';


var appStage = config?.env
const firebaseConfig =  (appStage === "prod") ? prodFirebaseConfig : testFirebaseConfig

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase Analytics is not available in all environments (e.g. during Jest tests
// or in browsers where IndexedDB is unavailable). Attempt to initialise
// Analytics only when it is actually supported. This prevents the runtime
// warning:
//   @firebase/analytics: Analytics: IndexedDB unavailable or restricted in this environment.
// We expose a (possibly undefined) `analytics` export so that production code
// can still import it safely.

export let analytics: Analytics | undefined;

// Only attempt to initialise analytics in browser-like environments.
if (typeof window !== "undefined") {
  // `isSupported` returns a promise resolving to `true` when the Analytics
  // SDK can be used in the current runtime. We defer the initialisation until
  // support is confirmed.
  isSupported()
    .then((supported) => {
      if (supported) {
        analytics = getAnalytics(app);
      }
    })
    // Swallow any errors because analytics is non-critical.
    .catch(() => undefined);
}

export const auth = getAuth(app);